import { actionCreatorFactory } from "typescript-fsa";

const actionCreator = actionCreatorFactory("EXPERIMENTS");

export type Experimenting = WtdModels.Partial<WtdModels.Experimenting, "id" | "experiment_name" | "variation">;

interface BootstrapResponse {
  experimentings?: Experimenting[];
}

export const bootstrapped = actionCreator<BootstrapResponse>("BOOTSTRAPPED");



// WEBPACK FOOTER //
// ./frontend/src/common/actions/Experiments.ts